// extracted by mini-css-extract-plugin
module.exports = {"oembed-cover":"_BroadcastReaction_oembed-cover_3w79Z","oembed":"_BroadcastReaction_oembed_2_mDr","spinner":"_BroadcastReaction_spinner_32r1e"};